<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  props: ['total', 'limit'],

  data () {
    return {
      minRemainingLeadsToShowModal: 100
    };
  },

  mounted () {
    if (this.remainingLeads <= this.minRemainingLeadsToShowModal) {
      this.openModal();
    }
  },

  computed: {
    remainingLeads () {
      return this.limit - this.total;
    }
  },

  methods: {
    openModal () {
      this.$refs['leads-limit-warning-modal'].show();
    },

    hideModal () {
      this.$refs['leads-limit-warning-modal'].hide();
    },

    openUpgradePlanModal () {
      this.hideModal();

      Bus.$emit('openUpgradePlanModal');
    }
  },
};
</script>

<template>
  <BModal
    id="leads-limit-warning-modal"
    ref="leads-limit-warning-modal"
    hide-footer="hide-footer"
    hide-header="hide-header"
    centered
  >

      <IconSalesflowTriangleExclamationRounded color="#FF2E56" :width=70 />

      <h2 v-if="remainingLeads <= 0" >Limite de leads atingido!</h2>
      <h2 class="text-big" v-else >Atenção!</h2>

      <strong
        v-show="remainingLeads > 0"
      >
        {{ remainingLeads > 1 ? 'Restam' : 'Resta' }} {{ remainingLeads }} {{ remainingLeads > 1 ? 'leads' : 'lead' }} para atingir o limite do seu plano.
      </strong>

      <p>
        Atualize seu plano ou pacote de leads agora mesmo para continuar a receber novas oportunidades para seu negócio
      </p>

      <button
        id="leads-limit-modal-upgrade-button"
        class="salesflow-btn salesflow-btn-secondary"
        v-on:click="openUpgradePlanModal"
      >
        Fazer upgrade agora!
    </button>

      <button class="cancel-button" v-on:click="hideModal">
        Cancelar
      </button>
  </BModal>
</template>

<style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  #leads-limit-warning-modal {
    .modal-dialog {
      max-width: 608px;
      height: 100%;
      border-radius: 16px;
      overflow: hidden;
      margin: 0px auto;

      .modal-content {
        border-radius: 16px;
        overflow: hidden;
      }

      .modal-body {
        padding: 3.5rem 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1.5rem;
        background-color: $salesflow-bg-content;

        h2 {
          @include salesflow-text($font-weight: 700);
          font-size: 1.25rem;
          margin: 0px;

          &.text-big {
            font-size: 1.5rem;
          }
        }

        strong {
          @include salesflow-subtitle($color: $salesflow-font-dark, $font-weight: 600);
          max-width: 70%;
          text-align: center;
        }

        p {
          @include salesflow-subtitle($color: $salesflow-font-dark);
          text-align: center;
          margin: 0px;
        }

        #leads-limit-modal-upgrade-button {
          &:hover {
            color: white;
            text-decoration: none;
          }
        }

        .cancel-button {
          padding: 0px;
          margin: 0px;
          border: 0px;
          outline: 0px;
          background-color: transparent;
          @include salesflow-text($color: $salesflow-font-gray, $font-weight: 600);
          text-decoration: underline;

          &:hover {
            color: $salesflow-purple-dark;
          }
        }
      }
    }
  }
</style>
